<template>
  <div id="October2024" class="202410">
    <div>
      <img src="~@/assets/images/202410/head.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202410/m/head.png" class="object-contain mx-auto md:hidden">
    </div>
    <section class="main mx-auto p-2 max-w-6xl">
      <div class="plan1 mb-6">
        <a href="https://store.liveabc.com/products/magazine/sale?tag=404" class="block" target="_blank">
          <img src="~@/assets/images/202410/con1.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202410/m/con1.png" class="object-contain mx-auto md:hidden">
        </a>
        <a href="https://store.liveabc.com/products/magazine/sale?tag=404" class="mt-6 block" target="_blank">
          <img src="~@/assets/images/202410/button-sub.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202410/m/button-sub.png" class="object-contain mx-auto md:hidden">
        </a>
      </div>
      <div class="plan2 mb-6">
        <a href="https://store.liveabc.com/products/magazine/sale?tag=407" class="block" target="_blank">
          <img src="~@/assets/images/202410/con2.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202410/m/con2.png" class="object-contain mx-auto md:hidden">
        </a>
        <a href="https://store.liveabc.com/products/recent" class="mt-6 block" target="_blank">
          <img src="~@/assets/images/202410/button-sub.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202410/m/button-sub.png" class="object-contain mx-auto md:hidden">
        </a>
      </div>
      <div class="plan3 mb-6">
        <div>
          <img src="~@/assets/images/202410/con3.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202410/m/con3.png" class="object-contain mx-auto md:hidden">
        </div>
        <div class="flex flex-wrap yellow-bg-book pb-8">
          <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" target="_blank" class="w-1/3 md:w-1/4 p-2 border border-dashed purple-border" v-for="(item, index) in bookData1" :key="index" :class="{ 'border-t-0': index === 0 || index === 1 || index === 2, 'md:border-t-0': index === 0 || index === 1 || index === 2 || index === 3, 'border-b-0': index === 9 || index === 10 || index === 11, 'md:border-b-0': index === 8 || index === 9 || index === 10 || index === 11 }">
            <img :src="item.img_url" class="object-contain">
          </router-link>
        </div>
        <a href="https://store.liveabc.com/products/magazine/sale?tag=407" class="mt-6 block" target="_blank">
          <img src="~@/assets/images/202410/button-more.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202410/m/button-more.png" class="object-contain mx-auto md:hidden">
        </a>
      </div>
      <div class="plan4 mb-6">
        <div class="yellow-bg-book pb-6">
          <a href="https://livejapanese.liveabc.com/login" class="block mb-4" target="_blank">
            <img src="~@/assets/images/202410/con4.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/202410/m/con4.png" class="object-contain mx-auto md:hidden">
          </a>
          <a href="https://liveabc-dokodemo.azurewebsites.net/scorm/post/JPN2202L005/" class="block mb-4" target="_blank">
            <img src="~@/assets/images/202410/test1.png" class="object-contain mx-auto">
          </a>
          <a href="https://liveabc-dokodemo.azurewebsites.net/scorm/post/JPN1601L17/" class="block mb-4" target="_blank">
            <img src="~@/assets/images/202410/test2.png" class="object-contain mx-auto">
          </a>
          <a href="https://liveabc-dokodemo.azurewebsites.net/scorm/post/JPN2207L15/" class="block mb-4" target="_blank">
            <img src="~@/assets/images/202410/test3.png" class="object-contain mx-auto">
          </a>
          <div class="flex justify-center">
            <div><img src="~@/assets/images/202410/jp.png" class="object-contain mx-auto"></div>
            <div class="p-3">
              <div class="mb-3"><img src="~@/assets/images/202410/jp-logo.png" class="object-contain"></div>
              <div class="mb-3"><img src="~@/assets/images/202410/jp-info.png" class="object-contain"></div>
              <div><img src="~@/assets/images/202410/JLPT.png" class="object-contain"></div>
            </div>
          </div>
        </div>

        <a href="https://store.liveabc.com/products/magazine/sale?tag=409" class="mt-6 block" target="_blank">
          <img src="~@/assets/images/202410/button-shop.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202410/m/button-shop.png" class="object-contain mx-auto md:hidden">
        </a>
      </div>
    </section>

    <div class="footer">
      <router-link :to="{ name: 'index' }" class="block" target="_blank">
        <div class="">
          <img src="~@/assets/images/202410/foot.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202410/m/foot.png" class="object-contain mx-auto md:hidden">
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
// import jump from 'jump.js'
export default {
  name: 'October2024',
  metaInfo () {
    return {
      title: '決戰十月週年慶典 LiveABC全館滿額贈好書',
      titleTemplate: null
    }
  },
  data () {
    return {
      bookData1: [
        { id: 7955, img_url: require('@/assets/images/202410/item/item.png') },
        { id: 7456, img_url: require('@/assets/images/202410/item/item1.png') },
        { id: 7399, img_url: require('@/assets/images/202410/item/item2.png') },
        { id: 9536, img_url: require('@/assets/images/202410/item/item3.png') },
        { id: 7647, img_url: require('@/assets/images/202410/item/item4.png') },
        { id: 7560, img_url: require('@/assets/images/202410/item/item5.png') },
        { id: 7137, img_url: require('@/assets/images/202410/item/item6.png') },
        { id: 6835, img_url: require('@/assets/images/202410/item/item7.png') },
        { id: 8166, img_url: require('@/assets/images/202410/item/item8.png') },
        { id: 8214, img_url: require('@/assets/images/202410/item/item9.png') },
        { id: 7012, img_url: require('@/assets/images/202410/item/item10.png') },
        { id: 6573, img_url: require('@/assets/images/202410/item/item11.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    // toTop (n) {
    //   jump(`${n}`, {
    //     duration: 500,
    //     offset: 0
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped>
#October2024 {
  background-color: #a3a1dc;
  .yellow-bg-book {
    background-color: #FFFCE7;
  }
  .purple-border {
    border-color: #A3A1DC;
  }
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 100%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
